import React from 'react';

const NotaFiscalConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/financeiro/nota-fiscal',
      component: React.lazy(() => import('./NotaFiscal')),
    },
  ],
};

export default NotaFiscalConfig;
